import FormDraftProvider from 'components/SankeyForm/FormDraftProvider';
import Field from 'ui/Field';
import { HStack, VStack } from 'ui/Layout';
import Popover from 'ui/Popover';

import {
  reportingPeriodOptions,
  statementTypeOptions,
} from '../../../constants';
import {
  FormColorSelect,
  FormNumberInput,
  FormSelect,
  FormSlider,
  FormTextInput,
  FormToggleableTextInput,
} from '../../SankeyForm';
import { useSankeyTitleInteraction } from '../../SankeyInteractionProvider/utils';

interface Props {
  children: React.ReactNode;
}

// TODO: Use FieldSet Chakra component
const TitleEditPopover: React.FC<Props> = ({ children }) => {
  const { isFocused, handleFocus, handleBlur } = useSankeyTitleInteraction();
  return (
    <Popover.Root
      // These lazy mount props are needed for FormDraftProvider to work properly
      // because we want it to pull latest upstream form values on each open
      // and not just once on initial mount.
      lazyMount
      unmountOnExit
      open={isFocused}
      onOpenChange={(e) => (e.open ? handleFocus() : handleBlur())}
    >
      <Popover.Trigger>{children}</Popover.Trigger>
      <Popover.Content zIndex="docked">
        <Popover.Arrow />
        <Popover.Body>
          <Popover.Title>Edit title</Popover.Title>
          <FormDraftProvider>
            <VStack alignItems="stretch">
              <FormTextInput
                field="company_name"
                label="Company name"
                size="sm"
              />
              <HStack>
                <FormNumberInput
                  field="fiscal_year"
                  label="Fiscal year"
                  fieldFontSize="xs"
                  size="sm"
                />
                <Field label="Reporting period" fontSize="xs">
                  <FormSelect
                    field="reporting_period"
                    options={reportingPeriodOptions}
                    size="sm"
                  />
                </Field>
              </HStack>
              <Field label="Financial statement type" fontSize="xs">
                <FormSelect
                  field="statement_type"
                  options={statementTypeOptions}
                  size="sm"
                />
              </Field>
              <FormToggleableTextInput
                label="Use custom title"
                fieldFontSize="xs"
                checkboxField="use_custom_title"
                textField="custom_title"
                size="sm"
              />
              <HStack gap={4}>
                <FormSlider label="Size" field="title_font_size" />
                <FormColorSelect label="Color" field="title_font_color" />
              </HStack>
            </VStack>
          </FormDraftProvider>
        </Popover.Body>
      </Popover.Content>
    </Popover.Root>
  );
};

export default TitleEditPopover;
